<div class="op-principal-loading-skeleton">
  <op-content-loader
    viewBox="0 0 180 80"
  >
    <svg:rect height="30%" rx="4" ry="4" width="117" x="75" y="30"/>
    <svg:circle cx="35" cy="42" r="35"></circle>
  </op-content-loader>
</div>